module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAANCAYAAACZ3F9/AAAAAXNSR0IArs4c6QAAAU1JREFUKFON0jFoU1EUxvH/Bw4iDhmc8gSpOLk4dHUq3YQOLQjuvfctjUumluIg1KW4ODXvFIeC4ODgIBQHncSlRVwCLXQpNHFocVWXfPpCLZHWpGe7nPs7fId7BVCWZct2G7hen8fUd0krnU7njepLOeevkn4MBoPtcUrSAnBcVdXsX7hn+1NELI6DKaW3wI2IuH8O5pzfAc3RAba/RcSDSXDN9tQolHRYVdXyPzDnvAS0bX+4TFRJt4BN5ZyP69zAF9srEfH+oj1TSguSngJ3gZMangCHwDXgNrBr+1VRFBvdbvdKo9FoS5oH7gF7wC9gaghtvyiK4lm/329Jemh7GtgHrv6JdVPSju2tZrP5stfrrUp6fAYjoo4xrJTSnKRcT7f9PCI+j/Se/BdOeMszeAQc2P444bsN25JmgDsqy3Ld9qPTfS5jfwKvfwOuBK4Ul9T+sQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/tkgl.png
// module id = EIw/
// module chunks = 3